import { IMeetingConnectionRequestParams } from './connections.dao';

enum MeetingLinkRole {
    Presenter = 'Presenter',
    Host = 'Host',
    Support = 'Support',
}

interface IMeetingLinkDTO {
    meetingLinkId: number;
    meetingId: number;
    label: string;
    role: MeetingLinkRole | null;
    meetingConnectionId: number | null;
    connectionGroupId: number | null;
    connectionInherited?: boolean;
    connectionLabel?: string;
    path: string;
    url: string;
    createdDateTime: string;
    updatedDateTime: string;
    createPanelistLinkEnabled?: boolean;
}

interface ICreateMeetingLinkRequest {
    label: string;
    role: MeetingLinkRole | null;
    meetingConnectionId: number | null;
    connectionInherited?: boolean;
    createPanelistLinkEnabled: boolean;
}

interface IUpdateMeetingLinkRequest extends ICreateMeetingLinkRequest {
    meetingLinkId: number;
}

interface IMeetingLinksListDTO {
    meetingLinks?: IMeetingLinkDTO[];
}

abstract class IMeetingLinksDAO {
    abstract getMeetingLinks(params: IMeetingConnectionRequestParams): Promise<IMeetingLinkDTO[]>;
    abstract createMeetingLink(params: IMeetingConnectionRequestParams & ICreateMeetingLinkRequest): Promise<IMeetingLinkDTO>;
    abstract updateMeetingLink(params: IMeetingConnectionRequestParams & IUpdateMeetingLinkRequest): Promise<IMeetingLinkDTO>;
}

export {
    IMeetingLinksDAO,
    IMeetingLinkDTO,
    ICreateMeetingLinkRequest,
    IUpdateMeetingLinkRequest,
    IMeetingLinksListDTO,
    MeetingLinkRole,
};
